'use strict';
var WptestController = /** @class */ (function () {
    /*@ngInject*/
    function WptestController(WptestService) {
        var _this = this;
        WptestService.getPage()
            .then(function (response) {
            _this.title = response.data.title.rendered;
            _this.content = response.data.content.rendered;
        });
    }
    return WptestController;
}());
export default WptestController;
//# sourceMappingURL=wptest.controller.js.map